import React, {lazy, Suspense} from 'react';
import {createRoot, hydrateRoot} from 'react-dom/client';
import {BrowserRouter, useLocation} from 'react-router-dom';
import {ThemeProvider} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {ThemeProvider as ContextThemeProvider} from './Context';
import theme from './theme';
import PublicRoot from './seo/PublicRoot';
import PageMetadata from './seo/PageMetadata';
import {isAccountRoute} from './seo/metadata';
import './index.css';
import './App.css';
// Public content neither initializes Firebase nor waits for account state.
const AccountApp = lazy(() => import('./App'));
function SiteRouter() {
  const {pathname} = useLocation();
  return <><PageMetadata/>{isAccountRoute(pathname) ?
    <Suspense fallback={<p role="status">Opening your account…</p>}><ContextThemeProvider><ThemeProvider theme={theme}><CssBaseline/><AccountApp/></ThemeProvider></ContextThemeProvider></Suspense>
    : <PublicRoot/>}</>;
}
const container = document.getElementById('root') as HTMLElement;
const app = <BrowserRouter><SiteRouter/></BrowserRouter>;
if (container.dataset.prerendered === 'true') hydrateRoot(container, app);
else createRoot(container).render(app);
